import React from 'react'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const SupplyOrderItemLink = ({ link }) => {
  return (
    <div className='supplyOrderItemLinks__one'>
        <div>
            {
                link.shortLink
            }
        </div>
        <div className='supplyOrderItemLinks__one-buttons'>
            <div onClick={e => {
                return navigator.clipboard.writeText(link.link);
            }}>
                <ContentCopyIcon />
            </div>
            <a href={link.link} target='_blank'>
                <OpenInNewIcon />
            </a>
        </div>
        
    </div>
  )
}

export default SupplyOrderItemLink